module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kdMyQC/tc-custom/9781614233329.jpg?1688954038921",
      "alt": "This image is the cover for the book Battle of Mine Creek: The Crushing End of the Missouri Campaign, Civil War Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Battle of Mine Creek: The Crushing End of the Missouri Campaign, Civil War Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In 1864, Union troops controlled much of the South, Sherman's men marched with impunity through Georgia and defeat at Gettysburg was a painful and distant memory. The Confederacy needed to stem the tide. Confederate major general Sterling Price led an army of twelve thousand troops on a desperate charge through Missouri to deliver the state to the Confederacy and dash President Lincoln's hopes for reelection. This daring campaign culminated with the Battle of Mine Creek. A severely outnumbered Union army crushed the Confederate forces in one of the war's largest and most audacious cavalry charges. Historian"), _c('br'), _vm._v("Jeff Stalnaker puts the reader in the saddle with the Union troopers as they destroy all hope for Rebel victory in the Trans-Mississippi.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeffrey D. Stalnaker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jeff Stalnaker lives in Mission, Kansas, with his wife, Jen, his daughter, Emma, and two dogs and a cat. He has a degree from the University of Kansas, with an emphasis in history and political science, is an avid student of history and is a local Kansas City singer/songwriter. He is also a World War II living historian, reenacting both the U.S. Army and British army.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0